module.exports = __webpack_public_path__ + "br.182f9e334da7c92b4fa9.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/br.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/br.svg
// module chunks = styles